export const USER_DATA = 'user';